import Component from './Component';
import React from 'react';

export default class ToggleButton extends Component {

	handleClick(e, value) {
		e.preventDefault();
		if (this.props.onChange) {
			this.props.onChange(value)
		}
		if (this.props.onBlur) {
			this.props.onBlur(value)
		}
	}


	render() {
		let value = this.props.value;
		if (value == null) {
			value = false;
		}
		if (typeof value == 'string') {
			value = parseInt(value);
		}
		let cn = 'btn btntoggle ' + (this.props.className ? this.props.className : '');
		if (value) {
			cn += ' btn-primary';
		}
		return (
			<button className={cn} onClick={(e) => this.handleClick(e, !value)}>{this.props.title}</button>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/ToggleButton.js